// extracted by mini-css-extract-plugin
module.exports = {"our_apps_wrapper":"our-apps-page_our_apps_wrapper__jwHZE","cards_wrapper":"our-apps-page_cards_wrapper__WjFSl"};